// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2b3fda9","453":"4770d84f","455":"310130a4"}[chunkId] + ".chunk.js";
};